const STANDARD_WIDTHS = [300, 600, 1200] as const;

export const normalizeDirectusWidth = (width?: number): number => {
  if (!width || width <= 0) return 600;
  for (const stdWidth of STANDARD_WIDTHS) {
    if (width <= stdWidth) {
      return stdWidth;
    }
  }
  return 1200;
};

export const generateDirectusSrcSet = (
  id?: string | null,
  maxWidth: number = 1200
) => {
  if (!id) return undefined;
  const strId = String(id).trim();
  if (strId.startsWith('http://') || strId.startsWith('https://')) {
    return undefined;
  }
  const baseUrl = (process.env.NEXT_PUBLIC_BASE_URL || '').replace(/\/$/, '');
  const cleanId = strId.replace(/^\/assets\//, '').replace(/^\//, '');
  if (maxWidth <= 600) {
    return `${baseUrl}/assets/${cleanId}?width=300&quality=80&format=webp 300w, ${baseUrl}/assets/${cleanId}?width=600&quality=80&format=webp 600w`;
  }
  return `${baseUrl}/assets/${cleanId}?width=300&quality=80&format=webp 300w, ${baseUrl}/assets/${cleanId}?width=600&quality=80&format=webp 600w, ${baseUrl}/assets/${cleanId}?width=1200&quality=80&format=webp 1200w`;
};

export const generateDirectusSrc = (
  id?: string | null,
  defaultWidth: number | 'original' = 600,
  quality: number = 80,
  format: string = 'webp'
) => {
  if (!id) return '';
  const baseUrl = (process.env.NEXT_PUBLIC_BASE_URL || '').replace(/\/$/, '');
  const strId = String(id).trim();
  if (strId.startsWith('http://') || strId.startsWith('https://')) {
    return strId;
  }
  const cleanId = strId.replace(/^\/assets\//, '').replace(/^\//, '');
  // Let Next Image optimize the original, or serve it directly in a lightbox.
  if (defaultWidth === 'original') return `${baseUrl}/assets/${cleanId}`;
  const optimizedWidth = normalizeDirectusWidth(defaultWidth);
  return `${baseUrl}/assets/${cleanId}?width=${optimizedWidth}&quality=${quality}&format=${format}`;
};
